import gql from 'graphql-tag';

const MIGRATION_FIELDS = `
  id
  status
  companyId
  companyName
  targetAdvisorId
  targetAdvisorEmail
  fileName
  appliedAt
  undoneAt
  createdAt
  totalCount
  foundCount
  notFoundCount
  appliedCount
  actions {
    id
    testatorId
    csvEmail
    dbEmail
    role
    emailMatches
    found
    previousAdvisorId
    newAdvisorId
    currentAdvisorId
    currentAdvisorEmail
    currentCompanyName
    applied
    undone
    errorMessage
  }
`;

export const PREVIEW_COMPANY_LEAD_MIGRATION_MUTATION = gql`
  mutation previewCompanyLeadMigration(
    $companyId: ID!
    $fileBase64: String!
    $fileName: String
  ) {
    previewCompanyLeadMigration(
      companyId: $companyId
      fileBase64: $fileBase64
      fileName: $fileName
    ) {
      ${MIGRATION_FIELDS}
    }
  }
`;

export const REFRESH_COMPANY_LEAD_MIGRATION_MUTATION = gql`
  mutation refreshCompanyLeadMigration($migrationId: ID!) {
    refreshCompanyLeadMigration(migrationId: $migrationId) {
      ${MIGRATION_FIELDS}
    }
  }
`;

export const EXECUTE_COMPANY_LEAD_MIGRATION_MUTATION = gql`
  mutation executeCompanyLeadMigration($migrationId: ID!) {
    executeCompanyLeadMigration(migrationId: $migrationId) {
      ${MIGRATION_FIELDS}
    }
  }
`;

export const UNDO_COMPANY_LEAD_MIGRATION_MUTATION = gql`
  mutation undoCompanyLeadMigration($migrationId: ID!) {
    undoCompanyLeadMigration(migrationId: $migrationId) {
      ${MIGRATION_FIELDS}
    }
  }
`;

export const FETCH_COMPANY_LEAD_MIGRATIONS_MUTATION = gql`
  mutation fetchCompanyLeadMigrations($companyId: ID) {
    fetchCompanyLeadMigrations(companyId: $companyId) {
      id
      status
      companyId
      companyName
      targetAdvisorId
      fileName
      appliedAt
      undoneAt
      createdAt
      totalCount
      foundCount
      appliedCount
    }
  }
`;
